module.exports = __webpack_public_path__ + "static/Inventiva-ca273faac121b1938aee732482dbd1a4.png";